import { columns } from "../../../../dtos/columns";
import { RespuestaInformeCMFDTO } from "../models/informeCMF";


export function useColumns() {

    const COLUMNS: columns<RespuestaInformeCMFDTO>[] = [
        {
            name: 'N° Operación',
            selector: (row) =>
                row.numeroOperacion,
            sortable: true,
            sortField: 'numeroOperacion',
            wrap: true,
            export: true
        },
        {
            name: 'RUT',
            selector: (row) =>
                row.rut,
            sortable: true,
            sortField: 'rut',
            wrap: true,
            export: true
        },
        {
            name: 'Nombre',
            selector: (row) =>
                row.nombre,
            sortable: true,
            sortField: 'nombre',
            wrap: true,
            export: true
        },
        {
            name: 'Plazo',
            selector: (row) =>
                row.plazo,
            sortable: true,
            sortField: 'plazo',
            wrap: true,
            export: true
        },
         {
            name: 'Monto',
            selector: (row) => {
                const value = row.monto;
                return typeof value === 'number' && !isNaN(value)
                    ? `UF ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 4 }).format(value)}`
                    : 'UF 0,0000';
            },
            sortable: true,
            sortField: 'monto',
            wrap: true,
            export: true,
        },

    ]
    return { COLUMNS };
}
